import { Row } from '@react-email/components';

const column = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return (
            <Row {...attributes} {...element.attributes}>
                {children}
            </Row>
        );
    },
    PreviewElement: ({ attributes, children }) => {
        return <Row {...attributes}>{children}</Row>;
    },
};

export default column;
